import Contract from "slotworks/utils/contracts/contract";
import Layers from "slotworks/graphics/layers/layers";
import {Tween, Easing} from "slotworks/utils/tween";
import Sequence from "slotworks/utils/contracts/sequence";

const DROP_SPEED = 0.5;
const SYMBOL_OFFSET_X = -24;
const SYMBOL_OFFSET_Y = 40;
const DROP_OFFSET_Y = -50;
const FADE_OUT_DURATION = 300;
const PARTICLES_ID = "scatter_particles";

class SGSatterParticles {

    public init() {
        let particles = Layers.SymbolAnimations.getParticle(PARTICLES_ID);
        particles.emit = false;
    }

    public playLandingParticlesAnimation(index: number): Contract<void> {
        let symbolPosition = Layers.MatrixContent.getPosition(`symbol_1_${index}`);
        return new Sequence([
            () => this.getDropAnimationContract(symbolPosition.x, symbolPosition.y),
            () => this.getFadeOutAnimationContract()
        ]);
    }

    private getDropAnimationContract(posX: number, posY: number): Contract<void> {
        let tweenPosition = {posX: posX + SYMBOL_OFFSET_X, posY: DROP_OFFSET_Y};
        let particles = Layers.SymbolAnimations.getParticle(PARTICLES_ID);
        let gotoPosY = posY - SYMBOL_OFFSET_Y;
        let duration = (gotoPosY - tweenPosition.posY) / DROP_SPEED;

        const tween = new Tween(tweenPosition);
        return new Contract<void>((resolve) => {
            tween.to({posY: gotoPosY}, duration);
            tween.easing(Easing.Sinusoidal.Out);
            tween.onStart(() => {
                particles.updateSpawnPos(tweenPosition.posX, tweenPosition.posY);
                particles.frequency = 0.001;
                particles.emit = true;
            });
            tween.onUpdate(() => {
                particles.updateSpawnPos(tweenPosition.posX, tweenPosition.posY);
            });
            tween.onComplete(() => {
                resolve(null);
            });
            tween.start();
        });
    }

    private getFadeOutAnimationContract(): Contract<void> {
        let particles = Layers.SymbolAnimations.getParticle(PARTICLES_ID);
        const tween = new Tween(particles);
        return new Contract<void>((resolve) => {
            tween.to({frequency: 0}, FADE_OUT_DURATION);
            tween.onComplete(() => {
                particles.frequency = 0;
                particles.emit = false;
                resolve(null);
            });
            tween.start();
        });
    }





}

export default new SGSatterParticles();
